import React, { useRef, useEffect, useState } from "react";
import { BlockPicker, SliderPicker } from "react-color";

const ColorWheel = ({ value, color, width = 200, onChange }) => {
  const canvasRef = useRef(null);
  const [selectedColor, setSelectedColor] = useState(value || color || "#000000");

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = "/colorWheel.png"; // ensure this is inside public/
    img.onload = () => {
      const scale = width / img.width;
      canvas.width = width;
      canvas.height = img.height * scale;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    };
  }, [width]);

  useEffect(() => {
    if (value && value !== selectedColor) setSelectedColor(value);
    else if (color && color !== selectedColor) setSelectedColor(color);
  }, [value, color]);

  const handleCanvasClick = (event) => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const rect = canvas.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const pixel = ctx.getImageData(x, y, 1, 1).data;
    const rgba = `rgba(${pixel[0]}, ${pixel[1]}, ${pixel[2]}, ${(pixel[3] / 255).toFixed(2)})`;

    setSelectedColor(rgba);
    if (onChange) onChange(rgba);
  };

  return (
    <div style={{ textAlign: "center", width, marginLeft:"10px" }}>
      {/* 🎨 Color Wheel */}
      <canvas
        ref={canvasRef}
        onClick={handleCanvasClick}
        style={{
          cursor: "crosshair",
          borderRadius: "50%",
          display: "block",
          margin: "0 auto",
          width: "100%",
        }}
      />

      {/* 🧩 Centered Color Controls */}
      <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <BlockPicker
            width="220px"
            color={selectedColor}
            onChange={(color) => {
              setSelectedColor(color.hex);
              onChange?.(color.hex);
            }}
            colors={[
              "#ff6900",
              "#fcb900",
              "#7bdcb5",
              "#00d084",
              "#8ed1fc",
              "#0693e3",
              "#abb8c3",
              "#eb144c",
              "#f78da7",
              "#9900ef",
              "#673ab7",
              "#795548"
            ]}
            triangle="top"
            onSwatchHover={(color, event) => console.log("Hovered:", color.hex)}
          />
        </div>

        <div style={{ marginTop: "12px", width: "220px" }}>
          <SliderPicker
            color={selectedColor}
            onChange={(color) => {
              setSelectedColor(color.hex);
              onChange?.(color.hex);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ColorWheel;
